import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

export const ContainerWrapper = styled.div`
	width: 100%;
	max-width: 1260px;
	margin: 0 auto;
	height: 100%;
`;
